import React, { Component, useState } from "react";
import { NavLink } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { Search } from "./Search";
import { RouteUrls } from "../configs/routeUrls";
import { AppLayoutElement, ElementType, LinkTarget } from "../utils/enums";
import { GreyColor } from "../configs/globals";
import SeamlessImmutable from "seamless-immutable";
import styled from "styled-components";

export const NavMenu = (props) => {
  const {
    isSearching,
    appModule,
    topMenuElements = [],
    isAuth = false,
    eformExternalServiceAddress = "",
    display,
    loggedUser = { aswAccountId: null, aswMainProfileId: null },
  } = props;

  const NavMenu = styled.div`
    @media screen and (max-width: 938px) {
      justify-content: space-between;
      position: absolute;
      display: ${display};
    }
  `;

  const [selected, setSelected] = useState([]);

  const handleDropdownMenu = (id) => {
    if (selected.includes(id)) {
      const currentSelected = selected.filter((item) => item !== id);
      setSelected(currentSelected);
    } else setSelected([...selected, id]);
  };

  const proposalSuffixData =
    loggedUser.aswAccountId && loggedUser.aswMainProfileId
      ? `/${loggedUser.aswAccountId}/${loggedUser.aswMainProfileId}`
      : "";

  return (
    <div className="menu-search">
      <div className="menu-search__container container">
        <NavMenu className="menu">
          <ul className="menu__list" id="menu" title="Menu głowne na stronie">
            <li className="menu__list-element menu__list-element--home">
              <NavLink
                to={RouteUrls.App.main}
                className="menu__link--home menu__link"
                title="Przejdź do strony głównej"
              >
                <i className="fas fa-home" aria-hidden="true" />
              </NavLink>
            </li>
            {SeamlessImmutable(topMenuElements)
              .asMutable({
                deep: true,
              })
              .filter((item) => {
                const showElement =
                  (item.onlyAfterLogged && isAuth) ||
                  item.onlyAfterLogged === false;

                const appModuleAccess =
                  (appModule.consultation &&
                    item.id === AppLayoutElement.menuElementConsultation) ||
                  (appModule.budget &&
                    item.id === AppLayoutElement.menuElementBudget) ||
                  (appModule.survey &&
                    item.id === AppLayoutElement.menuElementSurvey) ||
                  (appModule.probe &&
                    item.id === AppLayoutElement.menuElementProbe) ||
                  item.id >= AppLayoutElement.menuElementInitiative;

                return appModuleAccess && showElement;
              })
              .map((topMenuElement) => {
                if (topMenuElement.subitems.length) {
                  return (
                    <li
                      key={`topElement-${topMenuElement.id}`}
                      className="menu__list-element"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDropdownMenu(topMenuElement.id);
                      }}
                    >
                      <span className="menu__link">
                        {topMenuElement.label}
                        <i
                          className={`fas ${
                            !selected.includes(topMenuElement.id)
                              ? "fa-chevron-down"
                              : "fa-chevron-up"
                          }  menu__icon`}
                        />
                      </span>

                      <nav
                        className={`dropdown dropdown--first ${
                          !selected.includes(topMenuElement.id)
                            ? "dropdown__hide"
                            : ""
                        }`}
                      >
                        {topMenuElement.subitems
                          .sort((a, b) => a.order - b.order)
                          .filter(
                            (subitem) =>
                              (subitem.onlyAfterLogged && isAuth) ||
                              subitem.onlyAfterLogged === false
                          )
                          .map((subitem) => {
                            if (subitem.subitems.length) {
                              return (
                                <li
                                  className={`dropdown__item dropdown__item--second ${
                                    !selected.includes(topMenuElement.id)
                                      ? "dropdown__hide"
                                      : ""
                                  }`}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleDropdownMenu(subitem.id);
                                  }}
                                >
                                  <span className="menu__link menu__link--second">
                                    {subitem.label}

                                    <i
                                      className={`fas     ${
                                        !selected.includes(subitem.id)
                                          ? "fa-chevron-down"
                                          : "fa-chevron-up"
                                      }  dropdown__item-icon  dropdown__item-icon--second`}
                                    />
                                  </span>

                                  <nav
                                    className={`dropdown dropdown--third ${
                                      !selected.includes(subitem.id)
                                        ? "dropdown__hide"
                                        : ""
                                    }`}
                                  >
                                    {subitem.subitems
                                      .sort((a, b) => a.order - b.order)
                                      .filter(
                                        (subitem) =>
                                          (subitem.onlyAfterLogged && isAuth) ||
                                          subitem.onlyAfterLogged === false
                                      )
                                      .map((thirdItem) => (
                                        <li
                                          key={`topElement-${thirdItem.id}`}
                                          className="dropdown__item dropdown__item--third"
                                        >
                                          <a
                                            href={
                                              thirdItem.elementType ===
                                              ElementType.Link
                                                ? thirdItem.linkValue
                                                : `${eformExternalServiceAddress}/proposal/${thirdItem.eformId}${proposalSuffixData}`
                                            }
                                            className="menu__link menu__link--third"
                                            title={thirdItem.description}
                                            target={
                                              thirdItem.linkTarget ===
                                              LinkTarget.Self
                                                ? "_self"
                                                : "_blank"
                                            }
                                          >
                                            {thirdItem.label}
                                          </a>
                                        </li>
                                      ))}
                                  </nav>
                                </li>
                              );
                            }
                            return (
                              <li
                                key={`subItem-${subitem.id}`}
                                className="dropdown__item dropdown__item--second"
                              >
                                <a
                                  className="menu__link menu__link--second"
                                  href={
                                    subitem.elementType === ElementType.Link
                                      ? subitem.linkValue
                                      : `${eformExternalServiceAddress}/proposal/${subitem.eformId}${proposalSuffixData}`
                                  }
                                  target={
                                    subitem.linkTarget === LinkTarget.Self
                                      ? "_self"
                                      : "_blank"
                                  }
                                  title={subitem.description}
                                >
                                  {subitem.label}
                                </a>
                              </li>
                            );
                          })}
                      </nav>
                    </li>
                  );
                }

                if (
                  !Object.values(AppLayoutElement).includes(topMenuElement.id)
                ) {
                  return (
                    <li
                      key={`topElement-${topMenuElement.id}`}
                      className="menu__list-element"
                    >
                      <a
                        className="menu__link"
                        href={
                          topMenuElement.elementType === ElementType.Link
                            ? topMenuElement.linkValue
                            : `${eformExternalServiceAddress}/proposal/${topMenuElement.eformId}${proposalSuffixData}`
                        }
                        target={
                          topMenuElement.linkTarget === LinkTarget.Self
                            ? "_self"
                            : "_blank"
                        }
                        title={topMenuElement.description}
                      >
                        {topMenuElement.label}
                      </a>
                    </li>
                  );
                }

                return (
                  <li
                    key={`topElement-${topMenuElement.id}`}
                    className="menu__list-element"
                  >
                    <NavLink
                      className="menu__link"
                      to={
                        topMenuElement.elementType === ElementType.Link
                          ? topMenuElement.linkValue
                          : `${eformExternalServiceAddress}/proposal/${topMenuElement.eformId}${proposalSuffixData}`
                      }
                      title={topMenuElement.description}
                    >
                      {topMenuElement.label}
                    </NavLink>
                  </li>
                );
              })}
          </ul>
        </NavMenu>
        <div className="icons row row--space-20">
          <div
            className="icons__icon"
            id="hamburger-menu-switch"
            onClick={props.openMenu}
          >
            <i
              className={`${
                display === "block" ? "fas fa-times" : "fa fa-bars"
              }`}
              aria-hidden="true"
            />
          </div>
          {props.offices && props.offices.length > 1 && (
            <div
              className="icons__icon row row--align-center row--space-5"
              id="office-switch"
              onClick={props.openOffices}
            >
              <i className="material-icons" aria-hidden="true">
                account_balance
              </i>
              <div className="icons__info">Instytucja</div>
              <i className="fas fa-chevron-down icons__down" />
            </div>
          )}
        </div>
        {isSearching && (
          <BeatLoader
            color={GreyColor}
            loading={isSearching}
            size={6}
            sizeUnit={"px"}
          />
        )}
        {!isSearching && <Search onSearchProject={props.onSearchProject} />}
      </div>
    </div>
  );
};

NavMenu.defaultProps = {
  isSearching: false,
};
